export default __webpack_public_path__ + "static/media/wumpa.4cf40f9e.png";